import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=3812b1b6&scoped=true&"
import script from "./OurServices.vue?vue&type=script&lang=js&"
export * from "./OurServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812b1b6",
  null
  
)

export default component.exports